export function validatePhone(phone) {
    return /^[0-9+\s]*$/.test(phone);
  }

export function isPhoneTooShort(phone, minLength) {
    return phone.replace(/\D/g, '').length < minLength;
  }

// export function formatPhone(phone) { Si algun dia se quiere formatear como numero telefono chileno
//     const cleaned = phone.replace(/\D/g, '');
//     if (cleaned.length >= 9 && cleaned.startsWith('9')) {
//       return `+56 ${cleaned.substring(0, 1)} ${cleaned.substring(1, 5)} ${cleaned.substring(5, 9)}`;
//     }
//     return cleaned;
//   }
//   
// export function validatePhone(phone) {
//     const cleaned = phone.replace(/\D/g, '');
//     const isValid = cleaned.length === 9 && cleaned.startsWith('9');
//     return {
//       isValid,
//       message: isValid ? '' : 'El teléfono debe tener 9 dígitos y comenzar con 9'
//     };
//   }